import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Button,
  FormControlLabel,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Admin from "../Dashboard";
// import DeleteSchoolModal from "../School/DeleteSchoolModal";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString } from "libphonenumber-js";


const InfoItem = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="subtitle2" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mb: 2, wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal", }}>
      {value || "-"}
    </Typography>
  </Grid>
);

const formatPhoneNumber = (phone) => {
  if (!phone) return "-";

  const parsed = parsePhoneNumberFromString(phone);

  if (!parsed) return phone;

  return `+${parsed.countryCallingCode} ${parsed.nationalNumber}`;
};




const ConsultationModal = ({ open, onClose, application }) => {
  if (!application) return null;
  const data = application.data || {};
  

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 700,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 3,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6" fontWeight={700}>
            Consultation Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Grid container spacing={2} mt={2}>
         
              <InfoItem label="Name" value={data?.name || '-'} />
         
          
              <InfoItem label="Gender" value={data?.gender || '-'} />

          <InfoItem label="Nationality" value={data?.nationality || '-'} />
          <InfoItem
            label="DOB"
            value={data.dob ? dayjs(data.dob).format("DD/MM/YYYY") : "-"}
          />
          <InfoItem label="Email" value={data?.email || '-'} />
          <InfoItem
    label="Contact No"
    value={formatPhoneNumber(`+${data?.phone}`)}
  />
          <InfoItem label="Line" value={`${data?.line || '-'}`} />
          <InfoItem label="WhatsApp" value={`${data?.whatsapp || '-'}`} />
          <InfoItem label="Kakaotalk" value={`${data?.kakaotalk || '-'}`} />
          <InfoItem label="Wechat" value={`${data?.wechat || '-'}`} />
          <InfoItem label="Zalo" value={`${data?.zolo || '-'}`} />
          <InfoItem label="Registration By" value={`${data?.registrationBy || '-'}`} />
          <InfoItem label="Highest Education Level" value={`${data?.highestEducationLevel || '-'}`} />
          <InfoItem label="Current School" value={`${data?.currentSchool || '-'}`} />
          <InfoItem label="Current Grade" value={`${data?.currentGrade || '-'}`} />
          <InfoItem label="Desired Program of Study" value={`${data?.desiredProgramOfStudy || '-'}`} />
          <InfoItem
            label="Preferred Date"
            value={
              data.preferredDate
                ? dayjs(data.preferredDate).format("DD/MM/YYYY")
                : "-"
            }
          />
          <InfoItem label="Preferred Time Slot" value={data?.preferredTimeSlot || '-'} />
          <InfoItem label="Application Type" value={data?.applicationType || '-'} />
          <InfoItem label="Preferred School" value={data?.preferredSchool || '-'} />

          <Grid item xs={12}>
            <Typography variant="subtitle2" fontWeight={600}>
              Comments
            </Typography>
            <Typography variant="body2">{data?.comments || "-"}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};


export default function ConsultationApplications() {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const {t} = useTranslation();

  const userData = localStorage.getItem("student_data")
    ? JSON.parse(localStorage.getItem("student_data"))
    : "";
  
  const [openModal, setOpenModal] = useState(false);
const [selectedApp, setSelectedApp] = useState(null);

  // Pagination
  const [page, setPage] = useState(1);
  const limit = 10; // per page
  const [totalPages, setTotalPages] = useState(1);

  // Fetch consultations
  const getConsultations = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get-consultation-applications-by-student?page=${page}&limit=${limit}&id=${userData?._id}`
      );

      if (response.status === 200) {
        setList(response.data.data);

        setTotalPages(response.data.pagination.pages || 1);
      }
    } catch (error) {
      console.log("Error fetching consultations", error);
    }
  };

  useEffect(() => {
    getConsultations();
  }, [page]);

  // Delete
  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/delete-consultation-application/${id}`
      );
      if (res.status === 200) {
        setOpen(false);
        getConsultations();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit
  const handleEdit = (id) => navigate(`/admin/editConsultation/${id}`);

  // Status Change
  const handleSwitchChange = async (id, currentValue) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/consultation/status`, {
        id,
        status: !currentValue,
      });
      getConsultations();
    } catch (error) {
      console.log("Error updating status", error);
    }
  };

  const formatCategory = (value) => {
  if (!value) return "-";
  return value
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

  return (
    <>
      {/* <DeleteSchoolModal
        open={open}
        onClose={() => setOpen(false)}
        school={deleteItem.title}
        handleDelete={handleDelete}
        deleteSchoolId={deleteItem.id}
      /> */}

      {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "#177D84" }}
          onClick={() => navigate("/admin/addConsultation")}
        >
          Add
        </Button>
      </Box> */}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("S.No")}</TableCell>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("Email")}</TableCell>
              <TableCell>{t("Phone")}</TableCell>
              <TableCell>{t("Consultation Type")}</TableCell>
              <TableCell>{t("Activity Name")}</TableCell>
              <TableCell>{t("Actions")}</TableCell>
              {/* <TableCell>Status</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {list.map((item, index) => (
              <TableRow key={item._id}>
                <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                <TableCell>{item?.data?.name || "-"}</TableCell>
                <TableCell>{item?.data?.email || "-"}</TableCell>
                <TableCell>{formatPhoneNumber(`+${item?.data?.phone}`) || "-"}</TableCell>
                <TableCell>{`${item?.data?.applicationType}` || "-"}</TableCell>
                <TableCell>{`${item?.data?.application_name || "-"}` || "-"}</TableCell>
                

                {/* Delete */}
                <TableCell>
                  <IconButton
    onClick={() => {
      setSelectedApp(item);
      setOpenModal(true);
    }}
    title="View Details"
  >
    👁️
  </IconButton>
                  {/* <IconButton
                    onClick={() => {
                      setDeleteItem({
                        title: item.data?.title?.en,
                        id: item._id,
                      });
                      setOpen(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton> */}

                  {/* Edit */}
                  {/* <IconButton onClick={() => handleEdit(item._id)}>
                    <EditIcon />
                  </IconButton> */}
                </TableCell>

                {/* Toggle Status */}
                {/* <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={item.isShow}
                        onChange={() =>
                          handleSwitchChange(item._id, item.isShow)
                        }
                      />
                    }
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ConsultationModal
  open={openModal}
  onClose={() => setOpenModal(false)}
  application={selectedApp}
/>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
        <Button
          variant="outlined"
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </Button>
        <Button
          variant="outlined"
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </Button>
      </Box>
    </>
  );
}
